import type { FC } from "react";

import { InteractionModeChip } from "components/materials/page/interaction-mode/InteractionModeChip";
import { InteractionModeListbox } from "components/materials/page/interaction-mode/InteractionModeListbox";
import { InteractionMode, PageType } from "components/server-types";
import { Tooltip } from "mds/components/Tooltip";

export type ManageContentInteractionModeProps = {
  page: PageType;
  disabled: boolean;
  disabledTooltip?: string;
  onModeChange: (mode: InteractionMode) => void;
};

export const ManageContentInteractionMode: FC<ManageContentInteractionModeProps> = ({
  page,
  disabled,
  disabledTooltip,
  onModeChange,
}) => {
  if (page.interaction_mode === InteractionMode.STATIC || disabled) {
    return (
      <Tooltip content={disabledTooltip}>
        <InteractionModeChip hasTooltip={!!disabledTooltip} page={page} disabled />
      </Tooltip>
    );
  }

  return <InteractionModeListbox page={page} onModeChange={onModeChange} />;
};

ManageContentInteractionMode.displayName = "ManageContentInteractionMode";
